import { Button } from "../../../components/Button/Button.tsx";
import type { OnboardingStep } from "../types.ts";
import { UserOnboardingLayout } from "./UserOnboardingLayout.tsx";

export const UserOnboardingFormLayout = ({
  title,
  step,
  progress,
  children,
  onContinue,
  disabled = false,
  isLoading = false,
}: {
  title: string;
  step: OnboardingStep;
  progress: number;
  children: React.ReactNode;
  onContinue: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}) => (
  <div className="flex-col p-800 gap-600 rounded-300 bg-surface-primary-rest">
    <UserOnboardingLayout title={title} step={step} progress={progress}>
      {children}
    </UserOnboardingLayout>
    <div className="flex-row justify-end">
      <Button
        size="lg"
        variant="primary"
        iconName="ArrowRight"
        onClick={onContinue}
        disabled={disabled}
        loading={isLoading}
      >
        Continue
      </Button>
    </div>
  </div>
);
